import { transformEmailMessageDtoToModel } from "../EmailMessage";
import { EmailConversationDto } from "./EmailConversationDto";
import { EmailConversationModel } from "./EmailConversationModel";

export const transformEmailConversationDtoToModel = (
  dto: EmailConversationDto
): EmailConversationModel => ({
  ...dto,
  ...transformEmailMessageDtoToModel(dto),
  // the message transformer overwrites `name` with conv_id; for a
  // conversation `name` is the email subject and must be preserved
  name: dto.name,
});
